<template>
  <span v-if="svgContent" v-html-safe="svgContent" class="fp-icon" />
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from 'vue';
import { fetchSvgText } from '@/components/fpComponents/svgTextCache';

interface IconProps {
  src: string | Promise<string>;
  width?: string | number;
  height?: string | number;
}

const props = defineProps<IconProps>();

const svgContent = ref<string>('');

const parseSvgText = (text: string): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(text, 'image/svg+xml');
  const svg = doc.querySelector('svg');

  if (svg) {
    if (props.width) {
      svg.setAttribute('width', String(props.width));
    } else if (props.height) {
      svg.removeAttribute('width');
    }

    if (props.height) {
      svg.setAttribute('height', String(props.height));
    } else if (props.width) {
      svg.removeAttribute('height');
    }
  }

  return svg?.outerHTML ?? '';
};

const loadSvg = async(): Promise<void> => {
  const src = props.src;
  try {
    const text: string = typeof src === 'string' ? await fetchSvgText(src) : await src;
    if (src !== props.src) return;

    svgContent.value = parseSvgText(text);
  } catch (error) {
    if (src !== props.src) return;
    console.error('Błąd ładowania SVG', error);
    svgContent.value = '';
  }
};

onMounted(loadSvg);
watch(() => props.src, loadSvg);
</script>

<style scoped lang="scss">
.fp-icon {
  display: inline-flex;
  vertical-align: middle;
}
</style>
